/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { BrandButton, Typography } from '@zapier/design-system';
import type { IconName } from '@zapier/design-system';

const styles = css({
  'a, button': {
    font: `var(--zds-body-3, 600 14px/24px ${Typography.base.fontFamily}) !important`,
    height: 'var(--zds-size-36, 36px) !important',
    borderRadius: 'var(--zds-radius-large, 8px) !important',
    color: 'var(--zds-text-inverted, #FFFDF9) !important',
    borderColor: 'var(--zds-ui-brand, #FF4F00) !important',
    '&[data-size="small"]': {
      '[data-testid="iconContainer"]': {
        height: '20px !important',
        width: '20px !important',
      },
    },
  },

  'a:focus:not([disabled])::before, a:focus': {
    borderRadius: 'var(--zds-radius-large, 8px) !important',
  },

  '&[data-collapsed=true] span': {
    padding: '0 !important',
  },

  'button:hover:not(:focus-visible)': {
    backgroundColor: 'var(--zds-ui-brand-stronger, #CC3F00) !important',
    borderColor: 'var(--zds-ui-brand-stronger, #CC3F00) !important',
    boxShadow: 'none !important',
  },
  'button:focus-visible::before': {
    border: 'var(--zds-border-focus, 2px solid #695BE8) !important',
    borderRadius: 'var(--zds-radius-small, 3px) !important',
  },
});

type Props = {
  /**
   * Where the `Button` links to.
   */
  href?: string;
  /**
   * Name of the icon to render when `isCollapsed`.
   */
  iconName: IconName;
  /**
   * Indicates whether the button is collapsed.
   */
  isCollapsed: boolean;
  /**
   * The content of the button, which will also be used
   * for the `ariaLabel` when `isCollapsed`.
   */
  text: string;
  onClick?: React.MouseEventHandler;
};

const InAppSidebarSubheaderButton = (props: Props) => {
  // Use `Button` for both the text and `Icon` states
  // instead of `IconButton` so that the component can visually
  // transition from one state to the other. With `IconButton`,
  // the components would unmount and remount the next one.
  return (
    <div
      className="sidebar-create-menu-button"
      css={styles}
      data-zds
      data-collapsed={props.isCollapsed}
    >
      <BrandButton
        ariaLabel={props.text}
        iconBefore={props.iconName}
        href={props.href}
        isFullWidth={true}
        {...(props.isCollapsed && { color: 'brand' })}
        onClick={props.onClick}
        size="small"
      >
        {!props.isCollapsed && props.text}
      </BrandButton>
    </div>
  );
};

export default InAppSidebarSubheaderButton;
